const branding = {
  siteFooter: {
    url: 'https://yola.com',
    logo: 'https://assets.yolacdn.net/wl-logos/yola-273b558f.svg',
  },
  siteHeader: {
    url: 'https://yola.com',
    logo: 'https://assets.yolacdn.net/wl-logos/yola-273b558f.svg',
    ctaText: 'Start now',
  },
};

export default branding;
